export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = '39104a9d4794852d6e9bb09e66b136d7ed17f12b';
export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
